import React from 'react'

// components
import SubHeader from '../ficha-aviso/components/SubHeader'
import ModalDenuncia from './components/form-denunciar-aviso'
import Placeholder from './components/placeholder'

// mixins
import { FichaAvisoHeader } from './mixins'

const Component = ({
  productoLookAndFeel,
  isNavResized,
  aviso,
  applicant,
  visibleId,
  visibleModal,
  setVisibleModal,
  guardado,
  showAnchorPostular,
  postulacionRapida,
}) => {
  const hideModal = () => setVisibleModal('')

  if (!aviso) {
    return <Placeholder />
  }

  return (
    <FichaAvisoHeader>
      <SubHeader
        aviso={aviso}
        guardado={guardado}
        applicant={applicant}
        setVisibleModal={setVisibleModal}
        isNavResized={isNavResized}
        productoLookAndFeel={productoLookAndFeel}
        visibleId={visibleId}
        showAnchorPostular={showAnchorPostular}
        postulacionRapida={postulacionRapida}
      />

      <ModalDenuncia
        idAviso={aviso?.id}
        width={800}
        closeModal={hideModal}
        visible={visibleModal === 'modal-denunciar-aviso'}
      />
    </FichaAvisoHeader>
  )
}

export default Component
